<div class="flex">
  <span class="flex items-center justify-center h-10 min-w-[108px] rounded-md border border-ui-gray-light bg-ui-gray-900 text-ui-dark text-xl font-semibold mr-5 mt-[26px]">
    FOR
  </span>
  <div class="w-full">
    <label class="input-main-label block mt-0 mb-1">Delay, minutes</label>
    <avs-slider
      (valueChanged)="durationMinutesControl().setValue($event)"
      [max]="30"
      [min]="0"
      [value]="durationMinutes()"
    />
  </div>
</div>

<div class="severity-container">
  <label class="input-main-label block">Severity *</label>

  <mat-button-toggle-group
    class="main-toggle-group flex"
    [formControl]="severityControl()"
  >
    <mat-button-toggle
      class="flex-1"
      [value]="eIncidentSeverity.MINOR"
    >
      <avs-incident-severity-icon
        [severity]="eIncidentSeverity.MINOR"
        [showLabel]="true"
      />
    </mat-button-toggle>

    <mat-button-toggle
      class="flex-1"
      [value]="eIncidentSeverity.MAJOR"
    >
      <avs-incident-severity-icon
        [severity]="eIncidentSeverity.MAJOR"
        [showLabel]="true"
      />
    </mat-button-toggle>

    <mat-button-toggle
      class="flex-1"
      [value]="eIncidentSeverity.CRITICAL"
    >
      <avs-incident-severity-icon
        [severity]="eIncidentSeverity.CRITICAL"
        [showLabel]="true"
      />
    </mat-button-toggle>
  </mat-button-toggle-group>

  <p class="text-[10px] text-ui-gray-450">Major events notification will be batched (every {{ durationMinutes() }} mins).</p>

</div>
